import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.routes')
  .factory('RoutesAPI', RoutesAPI);

function RoutesAPI(): BringozApi {
  return {
    base: `/routes`,
    idKey: 'rid',
    infiniteScroll: {
      address: `/routes`,
      cmd: 'GET'
    },
    actions: {
      getRouteIdsByQuery: {
        address: 'ids',
        cmd: 'GET'
      },
      updateRoute: {
        address: '{routeId}',
        cmd: 'POST',
        updateable: true
      },
      setName: {
        address: '{routeId}/setName',
        cmd: 'POST',
        updateable: true
      },
      getRoutesBySyncIds: {
        address: 'syncIds',
        cmd: 'GET',
        updateable: true
      },
      getRoutesList: {
        address: 'list',
        cmd: 'GET',
        updateable: true
      },
      getSuggestedDeliveries: {
        address: '{routeId}/actions/deliveries',
        cmd: 'GET',
        updateable: true
      },
      assign: {
        address: '{routeId}/actions/assign/{agentId}',
        cmd: 'POST',
        updateable: true
      },
      assignAssistant: {
        address: '{routeId}/actions/assignAssistant',
        cmd: 'POST',
        updateable: true
      },
      assignAssistants: {
        address: 'actions/assignAssistants',
        cmd: 'POST'
      },
      assignLogisticVehicles: {
        address: 'actions/assignLogisticVehicles',
        cmd: 'POST'
      },
      getLogsTimeline: {
        address: '{routeId}/timeline',
        cmd: 'GET',
        updateable: true
      },
      deleteRoutes: {
        address: 'actions/delete',
        cmd: 'POST',
        updateable: true
      },
      resetRoutes: {
        address: 'actions/reset',
        cmd: 'POST',
        updateable: true
      },
      updateBranch: {
        address: 'actions/updateBranch',
        cmd: 'POST',
        updateable: true
      },
      associateAgent: {
        address: 'actions/updateAssociatedAgent',
        cmd: 'POST',
        updateable: true,
      },
      mergeRoutes: {
        address: 'actions/merge',
        cmd: 'POST',
        updateable: true
      },
      assignRoutesToAttachedAgents: {
        address: 'actions/assign',
        cmd: 'POST',
        updateable: true
      },
      putDelivery: {
        address: 'actions/deliveries',
        cmd: 'PUT',
        updateable: true
      },
      removeDelivery: {
        address: 'actions/deliveries',
        cmd: 'DELETE',
        updateable: true
      },
      generateRoutes: {
        address: 'actions/generate',
        cmd: 'PUT',
        updateable: false
      },
      getRoutes: {
        address: '?from={from}&to={to}',
        cmd: 'GET',
        updateable: true
      },
      getRoutesStatusesTotals: {
        address: 'totals/statuses',
        cmd: 'GET',
        updateable: false
      },
      updateTaskTimeWindow: {
        address: '{routeId}/edit/{taskId}/timewindow',
        cmd: 'POST',
        updateable: true
      },
      getRouteTasksData: {
        address: 'map',
        cmd: 'POST',
        updateable: true
      },
      // DEPRECATED
      // changeRouteResource: {
      //   address: '{routeId}/actions/changeResource',
      //   cmd: 'POST',
      //   updateable: true
      // },
      addRouteMetadata: {
        address: '{routeId}/actions/addMetadata',
        cmd: 'PUT',
        updateable: false
      }
    }
  }
}
